<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>{{ $t('route.unitariocreate') }}</span>
    </div>
    <span>{{ $t('unitario.description') }}</span>
    <el-input
      name="descripcion"
      v-model="unitario.unid_descripcion"
      v-validate="'required'"
    ></el-input>
    <!-- <span>{{ errors.first('descripcion') }}</span> -->
    <p />
    <span>{{ $t('unidad.symbol') }}</span>
    <el-input
      name="simbolo"
      v-model="unitario.unid_abreviatura"
      v-validate="'required'"
    ></el-input>
    <p />
    <span>{{ $t('unitario.type') }}</span>
    <el-select
      v-model="unitario.unid_tipo"
      name="tipo"
      :placeholder="$t('unitario.select')"
    >
      <el-option
        v-for="tipo in tipos"
        :key="tipo.tipo_id"
        :label="$t(tipo.tipo_descripcion)"
        :value="tipo.tipo_descripcion"
      >
      </el-option>
    </el-select>
    <p />
    <el-button
      :disabled="!validate()"
      size="medium"
      type="primary"
      icon="el-icon-check"
      @click="aplicar"
    ></el-button>
  </el-card>
</template>
<script>
  import { saveUnitario } from '@/api/unitario'

  export default {
    data() {
      return {
        unitario: {
          unid_descripcion: '',
          unid_abreviatura: '',
          unid_tipo: '',
          unid_estado: 1,
          usua_id: 0
        },
        tipos: [
          {
            tipo_id: 1,
            tipo_descripcion: 'Integer'
          },
          {
            tipo_id: 2,
            tipo_descripcion: 'Float'
          },
          {
            tipo_id: 3,
            tipo_descripcion: 'Date'
          },
          {
            tipo_id: 4,
            tipo_descripcion: 'Time'
          },
          {
            tipo_id: 5,
            tipo_descripcion: 'DateTime'
          },
          {
            tipo_id: 6,
            tipo_descripcion: 'String'
          }
        ],
        message: '',
        loading: false,
        page_size: 10,
        current_page: 1,
        passwordFieldType: 'password'
      }
    },
    methods: {
      aplicar() {
        saveUnitario(this.unitario)
          .then(response => {
            if (response.status === 201) {
              this.success()
            }
          })
          .catch(error => {
            this.error(error)
          })
      },
      validate() {
        if (
          this.unitario.unid_descripcion &&
          this.unitario.unid_abreviatura &&
          this.unitario.unid_tipo
        ) {
          return true
        } else {
          return false
        }
      },
      limpiarAndBack() {
        this.unitario = {
          unid_descripcion: '',
          unid_abreviatura: '',
          unid_tipo: '',
          unid_estado: 1,
          usua_id: 0
        }
        this.$router.push({ name: 'admin.unitario.index' })
      },
      limpiar() {
        this.usuario = {
          unid_descripcion: '',
          unid_abreviatura: '',
          unid_tipo: '',
          unid_estado: 1,
          usua_id: 0
        }
      },
      success() {
        this.$notify({
          title: this.$i18n.t('unitario.success'),
          message:
            this.$i18n.t('unitario.created') +
            ' ' +
            this.unitario.unid_descripcion,
          type: 'success',
          onClose: this.limpiarAndBack()
        })
      },
      error(e) {
        this.$notify.error({
          title: this.$i18n.t('unitario.error'),
          message: this.$i18n.t('unitario.notcreated') + ' ' + e,
          onClose: this.limpiar()
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .box-card {
    width: 480px;
  }
</style>
